import styles from './HeaderCell.module.css';
import HelpTooltip from 'components/overlays/helpTooltip/HelpTooltip';
import i18n from 'i18n';

interface HeaderCellProps {
  title: string;
  elevioHelpId: string;
}

const HeaderCell = (props: HeaderCellProps) => {
  return (
    <div>
      <span>{props.title}</span>
      <span id="serviceHelp" className={styles.questionInTableHeader} title={i18n.t('common:showHelp')}>
        <HelpTooltip id={props.elevioHelpId} />
      </span>
    </div>
  );
};

export default HeaderCell;
